import React from 'react';
import styled from 'styled-components';
import { Icon } from '@codex-brightworld/icons';

const Container = styled.div`
  text-align: center;
`;

const StyledIcon = styled(Icon)`
  width: 200px;
  height: 200px;
`;

function Spinner() {
  return (
    <Container>
      <StyledIcon
        icon="loader"
      />
    </Container>
  );
}

export default Spinner;
